import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const DataQualityWarningsInWebAuthoringQueryGql: DocumentNode = gql`
query DataQualityWarningsInWebAuthoringQuery($workbookIds: [String!]!, $flowIds: [String!]!, $publishedDatasourceIds: [String!]!, $databaseServerIds: [String!]!, $databaseTableIds: [String!]!, $publishedConnectionsLineageEnabled: Boolean!) {
  publishedDatasourcesConnection(filter: {luidWithin: $publishedDatasourceIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  workbooksConnection(filter: {luidWithin: $workbookIds}) {
    nodes {
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  flowsConnection(filter: {luidWithin: $flowIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  databaseServersConnection(filter: {luidWithin: $databaseServerIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  databaseTablesConnection(filter: {luidWithin: $databaseTableIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
}

${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
